
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.993 29.395l4.646-.151a1.075 1.075 0 00.895-.54l4.698-8.138c.056-.075.103-.156.14-.242l.043-.074.025-.172a.763.763 0 00-.017-.122 1.016 1.016 0 00-.02-.16l-.045-.113-.106-.16-4.495-8.345a1.075 1.075 0 00-.987-.57l-4.742.157.868 2.13L30.2 12.8l3.36 6.223-4.52.135a9.09 9.09 0 01-.046 2.153l4.436-.128L30 27.124l-3.119.094-.888 2.177z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.773 9.866a14.384 14.384 0 0110.171-4.213l4.468 10.954a9.085 9.085 0 010 6.862l-4.468 10.953a14.384 14.384 0 01-10.17-24.556zm5.544 1.047l4.674-.154.868 2.129-3.764.107 3.354 6.233 2.557-.077a9.09 9.09 0 01-.046 2.153l-2.51.072-3.435 5.95 3.835-.115-.888 2.177-4.785.155a.507.507 0 01-.172-.025l-.075-.043a.925.925 0 01-.484-.28l-.075-.042a.505.505 0 01-.107-.137l-4.495-8.343a1.076 1.076 0 01.02-1.045l4.698-8.138c.038-.086.085-.167.14-.242l.043-.075.137-.107a.766.766 0 01.113-.046c.048-.025.097-.047.148-.064l.122-.016.127-.027zm-.165 15.338l-3.293-6.123 3.43-5.94 3.299 6.113-3.436 5.95z","fill":"#F28729"}})])
          )
        }
      }
    